//处理接口返回的数据
import cards from "../../utils/cardsInfo";

const handle = {
  //处理折线图数据
  handleRecordData: (res, start, end, id) => {
    let info = [];//展示数据
    const showData = [];//展示折线图数据
    const { show, showItem, unit } = cards.healthyData.filter ((i) => (`${i.dict_id}` === `${id}`))[0];//前端字典
    const data = Object.entries (res.data).filter (i => show.includes (i[0]));//处理接口数据
    const d = data.map (v => ({ name: showItem[v[0]], data: v[1].trend }));//获取到的数据
    d.forEach (i => {
      i.data.forEach (v => {
        showData.push ({ values: v.values, name: i.name, date: v.date.replace (/-/g, ".") });
      });
    });//合成需要的数据格式
    if (data.length === 1) {//只显示一个数据
      data.forEach (v => {
        const m = v[1].mma;
        info.push (
          { name: "最高", value: m["max"], unit },
          { name: "平均", value: m["avg"], unit },
          { name: "最低", value: m["min"], unit },
        );
      });
    } else {//显示多个数据
      info = data.map (v => ({ name: v[1].name, value: `${v[1].mma.min}~${v[1].mma.max}`, unit }));
    }
    //接口请求成功但没有返回数据
    if (!showData.length) {
      Object.values (showItem).forEach (v => {
        showData.push (
          { name: v, date: start.replace (/-/g, "."), values: undefined },
          { name: v, date: end.replace (/-/g, "."), values: undefined }
        );
      });
    }
    return { info, showData };
  }
};

export default handle;
